import * as actionTypes from './actions';
import config from './../config';
export const initialState = {
    isOpen: [],
    isTrigger: [],
    isFormModal: false,
    isPropertyFormModal: false,
    isStyleFormModal: false,
    isFormatFormModal: false,
    isSingleRowClickModal: false,
    isRegeneratedModal: false,
    isFeedbackModal: false,
    generalModalId: '',
    singleRowClickModalId: '',
    componentId: '',
    propertyComponentId: '',
    styleComponentId: '',
    formatComponentId: '',
    buttonStatus: 'none',
    isLoaderModal: false,
    isExpanded: [],
    isDetailDrawer: false,
    ...config
};
const ableReducer = (state = initialState, action) => {
    let { payload } = action;

    let trigger = [];
    let open = [];
    switch (action.type) {
        case actionTypes.MODAL_OPEN:
            return {
                ...state,
                isFormModal: true,
                generalModalId: action?.id
            };
        case actionTypes.EXPANDABLE_MENU:
            return {
                ...state,
                isExpanded: payload
            }
        case actionTypes.REGENERATE_MODAL_CLOSE:
            return {
                ...state,
                isRegeneratedModal: !state.isRegeneratedModal,
                propertyComponentId: action?.id
            };
        case actionTypes.MODAL_CLOSE:
            return {
                ...state,
                isFormModal: false,
                generalModalId: action?.id
            };
        case actionTypes.LOADING_MODAL_OPEN:
            return {
                ...state,
                isLoaderModal: true,
            }
        case actionTypes.LOADING_MODAL_CLOSE:
            return {
                ...state,
                isLoaderModal: false,
            }
        case actionTypes.PROPERTY_MODAL_OPEN:
            return {
                ...state,
                isPropertyFormModal: true,
                propertyComponentId: action?.id
            };
        case actionTypes.PROPERTY_MODAL_CLOSE:
            return {
                ...state,
                isPropertyFormModal: false,
                propertyComponentId: action?.id
            };
        case actionTypes.STYLE_MODAL_OPEN:
            return {
                ...state,
                isStyleFormModal: true,
                styleComponentId: action?.id
            };
        case actionTypes.STYLE_MODAL_CLOSE:
            return {
                ...state,
                isStyleFormModal: false,
                styleComponentId: action?.id
            };
        case actionTypes.FORMAT_MODAL_OPEN:
            return {
                ...state,
                isFormatFormModal: true,
                formatComponentId: action?.id
            };
        case actionTypes.FORMAT_MODAL_CLOSE:
            return {
                ...state,
                isFormatFormModal: false,
                formatComponentId: action?.id
            };
        case actionTypes.SINGLE_ROW_MODAL_OPEN:
            return {
                ...state,
                isSingleRowClickModal: true,
                singleRowClickModalId: action?.id
            };
        case actionTypes.SINGLE_ROW_MODAL_CLOSE:
            return {
                ...state,
                isSingleRowClickModal: false,
                singleRowClickModalId: action?.id
            };
        case actionTypes.FEEDBACK_MODAL_OPEN:
            return {
                ...state,
                isFeedbackModal: true,
                componentId: action?.id
            };
        case actionTypes.FEEDBACK_MODAL_CLOSE:
            return {
                ...state,
                isFeedbackModal: false,
                componentId: action?.id
            };
        case actionTypes.CREATE_AND_CLOSE_BUTTON:
            return {
                ...state,
                buttonStatus: 'create'
            };
        case actionTypes.CREATE_AND_ADD_NEW_BUTTON:
            return {
                ...state,
                buttonStatus: 'addNew'
            };
        case actionTypes.UPDATE_BUTTON:
            return {
                ...state,
                buttonStatus: 'update'
            };
        case actionTypes.DELETE_BUTTON:
            return {
                ...state,
                buttonStatus: 'delete'
            };
        case actionTypes.COLLAPSE_MENU:
            return {
                ...state,
                collapseMenu: !state.collapseMenu
            };
        case actionTypes.COLLAPSE_TOGGLE:
            if (action.menu.type === 'sub') {
                open = state.isOpen;
                trigger = state.isTrigger;
                const triggerIndex = trigger.indexOf(action.menu.id);
                if (triggerIndex > -1) {
                    open = open.filter((item) => item !== action.menu.id);
                    trigger = trigger.filter((item) => item !== action.menu.id);
                }
                if (triggerIndex === -1) {
                    open = [...open, action.menu.id];
                    trigger = [...trigger, action.menu.id];
                }
            } else {
                open = state.isOpen;
                const triggerIndex = state.isTrigger.indexOf(action.menu.id);
                trigger = triggerIndex === -1 ? [action.menu.id] : [];
                open = triggerIndex === -1 ? [action.menu.id] : [];
            }
            return {
                ...state,
                isOpen: open,
                isTrigger: trigger
            };
        case actionTypes.NAV_CONTENT_LEAVE:
            return {
                ...state,
                isOpen: open,
                isTrigger: trigger
            };
        case actionTypes.NAV_COLLAPSE_LEAVE:
            if (action.menu.type === 'sub') {
                open = state.isOpen;
                trigger = state.isTrigger;
                const triggerIndex = trigger.indexOf(action.menu.id);
                if (triggerIndex > -1) {
                    open = open.filter((item) => item !== action.menu.id);
                    trigger = trigger.filter((item) => item !== action.menu.id);
                }
                return {
                    ...state,
                    isOpen: open,
                    isTrigger: trigger
                };
            }
            return { ...state };
        case actionTypes.CHANGE_LAYOUT:
            return {
                ...state,
                layout: action.layout
            };
        case actionTypes.CHANGE_SUB_LAYOUT:
            return {
                ...state,
                subLayout: action.subLayout
            };
        case actionTypes.LAYOUT_TYPE:
            return {
                ...state,
                layoutType: action.layoutType,
                headerBackColor: initialState.headerBackColor
            };
        case actionTypes.HEADER_BACK_COLOR:
            return {
                ...state,
                headerBackColor: action.headerBackColor
            };
        case actionTypes.RTL_LAYOUT:
            return {
                ...state,
                rtlLayout: !state.rtlLayout
            };
        case actionTypes.NAV_FIXED_LAYOUT:
            return {
                ...state,
                navFixedLayout: !state.navFixedLayout
            };
        case actionTypes.HEADER_FIXED_LAYOUT:
            return {
                ...state,
                headerFixedLayout: !state.headerFixedLayout,
                headerBackColor:
                    !state.headerFixedLayout && initialState.headerBackColor === 'header-default' ? 'header-blue' : state.headerBackColor
            };
        case actionTypes.BOX_LAYOUT:
            return {
                ...state,
                boxLayout: !state.boxLayout
            };
        case actionTypes.DRAWER_MODAL_OPEN:
            return {
                ...state,
                isDetailDrawer: !state.isDetailDrawer

            }
        case actionTypes.DRAWER_MODAL_CLOSE:
            return {
                ...state,
                isDetailDrawer: false
            }
        case actionTypes.RESET:
            return {
                ...state,
                layout: initialState.layout,
                subLayout: initialState.subLayout,
                collapseMenu: initialState.collapseMenu,
                layoutType: initialState.layoutType,
                headerBackColor: initialState.headerBackColor,
                rtlLayout: initialState.rtlLayout,
                navFixedLayout: initialState.navFixedLayout,
                headerFixedLayout: initialState.headerFixedLayout,
                boxLayout: initialState.boxLayout
            };
        default:
            return state;
    }
};
export default ableReducer;
